import get from 'lodash/get';
import flow from 'lodash/flow';
import htmlStripsService from '@Services/HtmlStripsService';
import Catalyst from '@Services/Catalyst';
import { getLinkLocation } from '@Components/Results/analytics/citationLinksTracking';

export const formatCitationType = (str) =>
  typeof str === 'string' ? htmlStripsService.getTitleWithoutHtml(str, 'full').toLowerCase() : str;

const getLinkOutContent = ({ link, trackingAttributes, citation }) => {
  const trackingDataContent = {
    // evar28
    publicationType: formatCitationType(
      (trackingAttributes.getTrackingAttrs || trackingAttributes.fullTextTrackingData)['data-tracking-publication-type'] ||
        citation.type ||
        ''
    ),
    indexTerms: (trackingAttributes.getTrackingAttrs || trackingAttributes.fullTextTrackingData)['data-tracking-index-terms'] || '',
    title:
      (trackingAttributes.getTrackingAttrs || trackingAttributes.fullTextTrackingData)['data-tracking-title'] ||
      (citation.citationJournals ? citation.citationJournals[0].issueTitle : '') ||
      '',
    volumeNumber:
      (trackingAttributes.getTrackingAttrs || trackingAttributes.fullTextTrackingData)['data-tracking-volume-number'] ||
      (citation.citationJournals ? citation.citationJournals[0].issueVolume : '') ||
      '',
    issn: get(citation, 'citationJournals[0].issn', ''),
    issueNumber: get(citation, 'citationJournals[0].issueNo', ''),
    onlineDate: (trackingAttributes.getTrackingAttrs || trackingAttributes.fullTextTrackingData)['data-tracking-online-date'] || '',
    id: (trackingAttributes.getTrackingAttrs || trackingAttributes.fullTextTrackingData)['data-tracking-id'] || citation.id || '',
    type: 'rx2:linkout:results:fulltext', // evar20
    linkOut: link, // evar37
  };
  return flow([
    (object) => Object.entries(object),
    // eslint-disable-next-line no-unused-vars
    (arr) => arr.filter(([key, value]) => value !== ''),
    (object) => {
      const entry = {};
      object.forEach(([key, value]) => {
        entry[key] = value;
      });
      return entry;
    },
  ])(trackingDataContent);
};

export const getAnalyticsForFullTextLink = ({ linksObject, trackingAttributes, citation, fullTextIndex, metadata, buttonElement }) => {
  if (Object.keys(trackingAttributes).length === 0) return;
  const currentFullTextIndex = trackingAttributes.index || fullTextIndex || 0;
  const linksKeys = linksObject ? Object.keys(linksObject) : [];
  const isLinkOut = linksKeys.length === 1;
  const isSourceChoice = linksKeys.length > 1;
  const isModalNoInfo = linksKeys.length === 0;
  const fullTextLocation = getLinkLocation(buttonElement, metadata);

  if (isLinkOut) {
    const content = getLinkOutContent({ link: Object.values(linksObject)[0], trackingAttributes, citation });

    // event204
    Catalyst.trackEvent('buttonClick', {
      buttonType: `${formatCitationType(citation.type)}:linkout:full text`, // evar124
    });

    // event25,event44
    Catalyst.trackEvent('linkOut', {
      content: [content],
      link: {
        location: `${fullTextLocation}:${currentFullTextIndex}`, // evar118
        name: 'Full Text', // evar119
        type: 'exit', // evar120
        destination: Object.values(linksObject)[0], // evar121
      },
    });
  } else if (isSourceChoice) {
    // event204
    Catalyst.trackEvent('buttonClick', {
      buttonType: `${formatCitationType(citation.type)}:modal:source_choice:full text`, // evar124
    });
  } else if (isModalNoInfo) {
    // event204
    Catalyst.trackEvent('buttonClick', {
      buttonType: `${formatCitationType(citation.type)}:modal:no info:full text`, // evar124
    });
  }
};

export const getAnalyticsForFullTextModalLinks = ({
  optionLink,
  trackingAttributes,
  citation,
  links,
  fullTextIndex,
  metadata,
  buttonElement,
}) => {
  const actualLink = optionLink === 'US Patent' ? links.USPTO : links.ESPACENET;
  const content = getLinkOutContent({ link: actualLink, trackingAttributes, citation });
  const fullTextLocation = getLinkLocation(buttonElement, metadata);

  // event25,event44
  Catalyst.trackEvent('linkOut', {
    content: [content],
    link: {
      location: `modal:${fullTextLocation}:${fullTextIndex}`, // evar118
      name: optionLink, // evar119
      type: 'exit', // evar120
      destination: actualLink, // evar121
    },
  });
};

export const getAnalyticsForFullTextModalCopy = () => {
  // event204
  Catalyst.trackEvent('buttonClick', {
    buttonType: 'button:copy document details', // evar124
  });
};
